<template>
    <div>
        <div class="container">
            <!--<div>-->
                <!--<vHeader></vHeader>-->
            <!--</div>-->
            <el-container>
                <el-main class="display-flex-auto">
                    <div class="container-main display-flex">
                        <div class="main-box" @click="routerPush(0)">
                            <img  src="../../../../static/img/newOne.png" alt="">
                        </div>
                        <div class="main-box" @click="routerPush(1)">
                            <img src="../../../../static/img/newTwo.png" alt="">
                        </div>
                        <div class="main-box" @click="routerPush(2)">
                            <img src="../../../../static/img/newThree.png" alt="">
                        </div>
                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>

<script>
    // import vHeader from '../../../components/header/index'
    export default {
        name: "main-knowledge",
        // components: {vHeader},
        methods: {
            routerPush(index) {
                if (index === 0) {

                    this.goMain('/shop')
                } else if (index === 1) {
                    this.goMain('/hope')
                } else {
                    this.goMain('/ideas')
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .container {
        overflow: hidden;
        width: 100%;
        height: 100vh;
        background: url("../../../../static/img/newZhishi.jpg");
        background-size: cover;
        .el-container {
            height: inherit;
        }
        .container-main {
            width: 100%;
            .main-box {
                height: 35vh;
                width: 33.33%;
                text-align: center;
                img{
                    height: inherit
                }
            }
            :first-child {

            }
            div {
                cursor: pointer;

            }
            .font {
                height: 40px;
                line-height: 40px;
                width: 300px;
                text-align: center;
                font-size: 18px;
                font-weight: 700;
                color: #fff;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/main/knowledge/main-knowledge.vue